const state = {
  showDialog: false,
  showErrorAlert: false,
  showSuccessAlert: false,
  selectItems: [
    { text: "AC Lis", value: { number: 50, name: "aclis" } },
    { text: "Arpol Toruń", value: { number: 51, name: "arpol_torun" } },
    { text: "Auto Club", value: { number: 53, name: "auto_club" } },
    { text: "Auto GT", value: { number: 55, name: "auto_gt" } },
    { text: "Auto Krak", value: { number: 56, name: "auto_krak" } },
    { text: "Automarket", value: { number: 60, name: "automarket" } },
    { text: "Dixi Car", value: { number: 123, name: "dixi_car" } },
    { text: "Germaz", value: { number: 65, name: "germaz" } },
    { text: "Gezet Gorzów", value: { number: 48, name: "gezet_gorzów" } },
    {
      text: "Gezet Zielona Góra",
      value: { number: 49, name: "gezet_zielona_gora" }
    },
    { text: "Grafix", value: { number: 80, name: "grafix" } },
    {
      text: "Kombat Częstochowa",
      value: { number: 81, name: "kombat_czestochowa" }
    },
    { text: "Kombat Opole", value: { number: 82, name: "kombat_opole" } },
    {
      text: "Michalski Motors",
      value: { number: 61, name: "michalski_motors" }
    },
    { text: "MM Cars", value: { number: 68, name: "mm_cars" } },
    { text: "Motor Centrum", value: { number: 69, name: "motor_centrum" } },
    { text: "Parexbud", value: { number: 83, name: "parexbud" } },
    {
      text: "PGD Bielsko-Biała",
      value: { number: 70, name: "pgd_bielsko_biala" }
    },
    { text: "PGD Sosnowiec", value: { number: 72, name: "pgd_sosnowiec" } },
    { text: "PGD Warszawa", value: { number: 73, name: "pgd_warszawa" } },
    { text: "Polody POZNAŃ", value: { number: 74, name: "polody_poznan" } },
    {
      text: "Polody Przeźmierowo",
      value: { number: 127, name: "polody_przezmierowo" }
    },
    { text: "RM Filipowicz", value: { number: 76, name: "rm_filipowicz" } },
    { text: "SATALL", value: { number: 84, name: "satall" } },
    { text: "Wojtanowicz", value: { number: 87, name: "wojtanowicz" } },
    { text: "Zaborowski", value: { number: 129, name: "zaborowski" } }
  ]
};

const getters = {
  form: (state: {}) => {
    return state;
  }
};

const mutations = {};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions
};
